import { helpers } from "../../../../packages/helpers";
import { getRole } from "./get-author-role";
import type { ApiAuthor, Author } from "../../types";

const { getStringValue } = helpers.text;

type Params = {
  author?: ApiAuthor;
  userId?: string;
};

const getAuthorData = ({ author, userId = "" }: Params): Author => {
  const authorId = getStringValue(author?.id);
  const authorRole = getStringValue(author?.facilities?.role); // TODO - уйти от вытаскивания роли

  return {
    id: authorId,
    name: {
      first: getStringValue(author?.passport?.firstName),
      last: getStringValue(author?.passport?.lastName),
      middle: getStringValue(author?.passport?.middleName),
    },

    role: getRole(authorId, userId, authorRole),
  };
};

export { getAuthorData };
